// extracted by mini-css-extract-plugin
export default {"container":"Home_container__1VwHG","loader":"Home_loader__RYBui","movies":"Home_movies__o+unb"};